module.exports = __webpack_public_path__ + "static/media/pdf-icon.3f43df44.svg";